import React, { useState } from 'react';

function Navbar() {
  const [dropOpen, setDropOpen] = useState(false);

  return (
    <>
      <nav className="navbar navbar-expand-lg bord blur">
        <div className="container">
          <a className="logo icon-img-100" href="/">
            <img src="/light/assets/imgs/spob/logo.png" alt="SPOB Nigeria" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="icon-bar">
              <i className="ti-bar-chart-outline"></i>
            </span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link" href="/">
                  <span className="rolling-text">Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/light/page-about">
                  <span className="rolling-text">About Us</span>
                </a>
              </li>
              <li
                style={{ position: 'relative' }}
                onMouseEnter={() => setDropOpen(true)}
                onMouseLeave={() => setDropOpen(false)}
              >
                <a className="nav-link" href="/light/page-services2" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span className="rolling-text">Initiatives</span>
                  <i className="ti-angle-down" style={{ fontSize: '9px' }}></i>
                </a>
                {dropOpen && (
                  <ul
                    style={{
                      display: 'block',
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      background: '#fff',
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      padding: '10px 0',
                      minWidth: '290px',
                      listStyle: 'none',
                      margin: 0,
                      boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                      zIndex: 9999,
                    }}
                  >
                    <li style={{ padding: '0' }}>
                      <a href="/light/initiative-health" style={{ display: 'block', padding: '9px 22px', color: '#222', fontSize: '13px', fontWeight: 500 }}>Health Awareness &amp; Community Outreach</a>
                    </li>
                    <li style={{ padding: '0' }}>
                      <a href="/light/initiative-nsuei" style={{ display: 'block', padding: '9px 22px', color: '#222', fontSize: '13px', fontWeight: 500 }}>School Uniform Equity (NSUEI)</a>
                    </li>
                    <li style={{ padding: '0' }}>
                      <a href="/light/initiative-flasi" style={{ display: 'block', padding: '9px 22px', color: '#222', fontSize: '13px', fontWeight: 500 }}>Foundational Learning (FLASI)</a>
                    </li>
                    <li style={{ padding: '0' }}>
                      <a href="/light/initiative-yoruba" style={{ display: 'block', padding: '9px 22px', color: '#222', fontSize: '13px', fontWeight: 500 }}>Yoruba Heritage &amp; Language</a>
                    </li>
                    <li style={{ padding: '0' }}>
                      <a href="/light/initiative-eco" style={{ display: 'block', padding: '9px 22px', color: '#222', fontSize: '13px', fontWeight: 500 }}>Eco-Awareness &amp; Sustainability</a>
                    </li>
                    <li style={{ padding: '0' }}>
                      <a href="/light/initiative-vocational" style={{ display: 'block', padding: '9px 22px', color: '#222', fontSize: '13px', fontWeight: 500 }}>Vocational Skills &amp; Empowerment</a>
                    </li>
                    <li style={{ padding: '6px 22px 0', borderTop: '1px solid #f0f0f0', marginTop: '6px' }}>
                      <a href="/light/page-services2" style={{ display: 'block', padding: '9px 0', color: '#888', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px' }}>View All Initiatives →</a>
                    </li>
                  </ul>
                )}
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/light/blog-classic">
                  <span className="rolling-text">Blog &amp; Updates</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/light/page-contact">
                  <span className="rolling-text">Contact Us</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="nav-butn">
            <a
              href="/light/page-contact"
              className="butn butn-md butn-bord radius-30"
            >
              <span>Donate</span>
            </a>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
